import { authService } from "../services/auth";
import { ONBOARDING_FIRST_PATH } from "../config/onboardingRoutes";

/** After JWTs from email/password: register vs sign-in tab drives first destination. */
export function completeAuthFlowAfterToken(navigate, isRegistrationFlow) {
  authService.fetchUser(
    () => {
      const current = JSON.parse(localStorage.getItem("currentUser") || "{}");
      const isDone = current?.features?.onboarding?.completed;
      if (isRegistrationFlow) {
        navigate(isDone ? "/audit/" : ONBOARDING_FIRST_PATH);
      } else {
        navigate("/audit/");
      }
    },
    () => navigate(isRegistrationFlow ? ONBOARDING_FIRST_PATH : "/audit/")
  );
}

/** After social OAuth redeem: destination from server (user profile), then sync user-config. */
export function navigateAfterOAuthExchange(navigate, onboardingCompleted) {
  const toAudit = onboardingCompleted === true;
  authService.fetchUser(
    () => navigate(toAudit ? "/audit/" : ONBOARDING_FIRST_PATH),
    () => navigate(toAudit ? "/audit/" : ONBOARDING_FIRST_PATH)
  );
}
